import React, { useContext } from "react";
import img1 from "../assets/image/parallax1.jpg";
import translations from "../data/langData";
import { LanguageContext } from "../context/LanguageContext";
const Contact = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  return (
    <>
      <div className="become-an-instructor-section section section-padding jarallax">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 offset-xl-6">
              {/* Instructor Register From Start */}
              <div className="instructor-register-from">
                <h4 className="title">
                  {t.contactweTitle}
                  <br />
                  <p
                    style={{
                      fontSize: "15px",
                      opacity: "0.7",
                      fontWeight: "normal",
                    }}
                  >
                    {t.contactDesc}
                  </p>
                </h4>

                <form action="#" className="become-teacher-form">
                  <div className="row">
                    <div className="col-md-6 col-12 mb-15">
                      <input
                        type="text"
                        placeholder={`${t.name}*`}
                        name="name"
                      />
                    </div>
                    <div className="col-md-6 col-12 mb-15">
                      <input
                        type="email"
                        placeholder={`${t.lastname}*`}
                        name="email"
                      />
                    </div>
                    <div className="col-md-12 col-12 mb-15">
                      <input
                        type="email"
                        placeholder={`${t.email}*`}
                        name="email"
                      />
                    </div>
                    <div className="col-md-12 col-12 mb-15">
                      <input
                        type="text"
                        placeholder={`${t.mobil}*`}
                        name="phone"
                      />
                    </div>
                    <div className="col-12 mb-15">
                      <textarea
                        name="message"
                        placeholder={`${t.note}*`}
                        defaultValue={""}
                      />
                    </div>
                    <div className="col-12 text-center">
                      <button className="btn btn-primary btn-hover-secondary">
                        {t.submit}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              {/* Instructor Register From End */}
            </div>
          </div>
        </div>
      </div>

      <div>
        {/* <div className="contact-form-section section section-padding mt-5">
          <div className="container">
            <div className="row">
              <div className="offset-lg-2 col-lg-8">
                <div className="contact-title max-width-600">
                  <h2 className="title">Bizimlə Əlaqə Saxlayın</h2>
                  <p className="mt-3" style={{ opacity: "0.8" }}>
                    Əməkdaşlıq istəyiniz və digər fikirləriniz üçün bizimlə
                    əlaqə saxlayın.
                  </p>
                </div>
                <div className="contact-form">
                  <form
                    action="https://htmldemo.net/maxcoach-v1/maxcoach/assets/php/contact-mail.php"
                    id="contact-form"
                    method="post"
                  >
                    <div className="row max-mb-n30">
                      <div className="col-md-6 col-12 max-mb-30">
                        <input type="text" placeholder="Adınız *" name="name" />
                      </div>
                      <div className="col-md-6 col-12 max-mb-30">
                        <input
                          type="email"
                          placeholder="Soyadınız *"
                          name="email"
                        />
                      </div>
                      <div className="col-md-6 col-12 max-mb-30">
                        <input
                          type="email"
                          placeholder="Email ünvanınız *"
                          name="email"
                        />
                      </div>
                      <div className="col-md-6 col-12 max-mb-30">
                        <input
                          type="text"
                          placeholder="Əlaqə nömrəniz *"
                          name="subject"
                        />
                      </div>
                      <div className="col-12 max-mb-30">
                        <textarea
                          name="message"
                          placeholder="Mesajınız *"
                          defaultValue={""}
                        />
                      </div>
                      <div className="col-12 text-center max-mb-30">
                        <button className="btn btn-primary btn-hover-secondary btn-width-180 btn-height-60">
                          Göndər
                        </button>
                      </div>
                    </div>
                  </form>
                  <p className="form-messege" />
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="contact-information-section section section-padding-bottom py-5">
          <div className="container">
            <div className="row margin-bottom-85">
              <div className="col-12">
                <div className="contact-title max-width-740">
                  <h2 className="title">{t.contactustitle}</h2>
                  <p className="mt-3" style={{ opacity: "0.8" }}>
                    {t.contactusdesc}
                  </p>
                </div>
              </div>
            </div>
            <div
              className="row justify-content-center align-items-center"
              style={{ marginTop: "80px", marginBottom: "80px" }}
            >
              <div className="col-lg-6 col-md-6 col-sm-12 col-12 max-mb-30">
                {/* Single Contact Info Start */}
                <div className="contact-info">
                  <div className="icon">
                    <i className="fa fa-map-marker-alt" />
                  </div>
                  <div>
                    <h4 className="title"> {t.address}</h4>
                    <span className="info-text"> {t.addressDesc}</span>
                  </div>
                </div>
                {/* Single Contact Info End */}
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-12 max-mb-30">
                {/* Single Contact Info Start */}
                <div className="d-flex justify-content-end">
                  <div className="contact-info">
                    <div className="icon">
                      <i className="fa fa-phone" />
                    </div>
                    <div>
                      <h4 className="title"> {t.contactwe}</h4>
                      <span className="info-text">
                        <a href="tel:+994704125544">+ 994 70 412 55 44</a>
                        <br />
                        {t.email} :{" "}
                        <a href="mailto:turanozbahceci@turanozbahceci.com">
                          turanozbahceci@turanozbahceci.com
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
                {/* Single Contact Info End */}
              </div>
            </div>
            <div className="row g-3" style={{ marginTop: "70px" }}>
              <h2 className="title text-center">{t.contactsocial}</h2>
              <div className="col-2 p-0">
                <a
                  href="https://www.facebook.com/ozbahceci.az"
                  target="_blank"
                  className="iconBoxContact"
                >
                  <i class="fa-brands fa-facebook-f"></i>
                </a>
              </div>
              <div className="col-2 p-0">
                <a
                  href="https://www.instagram.com/ozbahcheci/"
                  target="_blank"
                  className="iconBoxContact"
                >
                  <i class="fa-brands fa-instagram"></i>
                </a>
              </div>
              <div className="col-2 p-0">
                <a
                  href="https://www.tiktok.com/@turanozbahceci?lang=tr-TR"
                  target="_blank"
                  className="iconBoxContact"
                >
                  <i class="fa-brands fa-tiktok"></i>
                </a>
              </div>
              <div className="col-2 p-0">
                <a
                  href="https://www.linkedin.com/in/turan-ozbahceci-793213139/"
                  target="_blank"
                  className="iconBoxContact"
                >
                  <i class="fa-brands fa-linkedin"></i>
                </a>
              </div>
              <div className="col-2 p-0">
                <a
                  href="https://www.youtube.com/channel/UCmSeMwPTRlAaY4NN2Bdl-6w"
                  target="_blank"
                  className="iconBoxContact"
                >
                  <i class="fa-brands fa-youtube"></i>
                </a>
              </div>
              <div className="col-2 p-0">
                <a
                  href="https://t.me/turanozbahceci"
                  target="_blank"
                  className="iconBoxContact"
                >
                  <i class="fa-brands fa-twitter"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
